import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { createContext } from "react";
import { saveInSession } from '../../controller/session';
import { Button, ButtonGroup } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import './auth.css';
import { Redirect } from "react-router-dom";

export function salirForm(logout) {
  window.close();
  logout();
  return;
}

function renderForm(callbackPath, urlRedirect, children, logout) {
  return (
    <div className="auth-wrapper">

      <Redirect to={callbackPath}></Redirect>
      <div className="button-logout">
        <ButtonGroup color="primary" aria-label="primary button group">
          <Button onClick={() => salirForm(logout)}>
            Cerrar Sesion
          </Button>
        </ButtonGroup>
      </div>
      {
        children
      }

    </div>
  );
}



function LoginButton({ urlRedirect, callbackPath, children }) {

  const Auth0Context = createContext();
  const { isLoading, isAuthenticated, user, logout, loginWithRedirect } = useAuth0();


  if (isLoading) {
    return (
      <div className="loading-wrapper">
        <LinearProgress />
        <div>
          Cargando información del usuario ...
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    saveInSession('authUserColaborador', { user: { ...user }, type: "auth0" });
    return renderForm(callbackPath, urlRedirect, children, logout);
  } else {
    sessionStorage.clear();
    loginWithRedirect();
  }
}

export default LoginButton;